export default name => {

    if (name === null)
        return true

    const chars = "A-ZÁÉÍÓÚÂÊÎÔÛÃÕÄËÏÖÜÇ'"

    const valid = !!name.trim().match(new RegExp(
        `^[${chars}]{2,}\\s([${chars}]{1,}\\s?)*[${chars}]{2,}$`
    ))

    return valid
}